import { Rspndr } from '@hakimo-ui/hakimo/types';
import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { useRef } from 'react';
import { useMutation, useQueryClient } from 'react-query';

export function useRspndrIncidents(
  onSuccess?: (rspndr: Rspndr) => void,
  onError?: (err: Error) => void,
  getApiToken?: () => Promise<string>,
  tenantId?: string,
  rspndrUrl?: string
) {
  const url = rspndrUrl || '';
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();
  const getApiTokenRef = useRef(getApiToken);
  getApiTokenRef.current = getApiToken;

  return useMutation<Rspndr, Error, Rspndr | null>(
    async (data) => {
      const token = getApiTokenRef.current
        ? await getApiTokenRef.current()
        : '';
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-RSPNDR-TENANT-ID': tenantId || 'hakimo',
          'X-RSPNDR-API-TOKEN': token,
        },
        body: JSON.stringify(data),
      });
      return httpClient<Rspndr>(request, { noAuth: true });
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['rspndr']);
        if (onSuccess) onSuccess(data);
      },
      onError,
    }
  );
}

export default useRspndrIncidents;
